import React from 'react';
import './user-message.scss';

interface UserMessageProps {
  text?: string;
  children?: React.ReactNode;
  avatarUrl?: string;
  initials?: string;
  firstName?: string;
  lastName?: string;
  backgroundColor?: string;
}

const UserMessage: React.FC<UserMessageProps> = ({ 
  text = '', 
  children,
  avatarUrl,
  initials = '',
  firstName = '',
  lastName = '',
  backgroundColor
}) => {
  const displayInitials = React.useMemo(() => {
    if (initials) return initials;
    const first = firstName?.[0] || '';
    const last = lastName?.[0] || '';
    return `${first}${last}`.toUpperCase() || 'U';
  }, [initials, firstName, lastName]);

  return (
    <div className="v2-user-message">
      {avatarUrl ? (
        <img src={avatarUrl} alt="user avatar" className="v2-user-message__avatar" />
      ) : (
        <div className="v2-user-message__avatar-placeholder">
          {displayInitials}
        </div>
      )}

      <div 
        className="v2-user-message__bubble"
        style={{ backgroundColor: backgroundColor }}
      >
        {children || <div dangerouslySetInnerHTML={{ __html: text }} />}
      </div>
    </div>
  );
};

export default UserMessage;
